export default "__VITE_ASSET__Wh0JIL5Z__"